import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import de from 'vuetify/es5/locale/de'
import App from './App.vue'
import router from './router'

Vue.use(VueCompositionAPI)
Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { de },
    current: 'de'
  },
  theme: {
    themes: {
      light: {
        primary: '#17BBEF',
        secondary: '#1a1a1a',
        accent: '#00BEFA',
        background: '#f7f8f9'
      }
    }
  }
})

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
